import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { DepartamentoDTO } from '../../../../core/models/notificacion/departamento-DTO';
import { BodyResponse } from 'src/app/core/models/general/body-response';

const API_URL = environment.apiUrlNotificacion;

@Injectable()
export class DepartamentoService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getDepartamentoService() {
        return this.http.get<BodyListResponse<DepartamentoDTO>>(
            API_URL + '/api/v1/departamento/todos'
        );
    }

    guardarDepartamentoService(departamentoDTO: DepartamentoDTO) {
        return this.http.post(API_URL + '/api/v1/departamento', departamentoDTO);
    }

    getDepartamentoPorCodigoDepartamentoService(codigoDepartamento: string) {
        return this.http.get<BodyResponse<DepartamentoDTO>>(
            API_URL + '/api/v1/departamento/' + codigoDepartamento
        );
    }
}
